import { type FunnelStatus } from 'src/api/generated';

export interface UpdateFunnelStatusParams {
  id: number;
  data: Partial<FunnelStatus>;
}

export interface UpdateFunnelStatusContext {
  params: UpdateFunnelStatusParams;
  previousStatus?: FunnelStatus;
}

/**
 * Creates an optimistic funnel status for cache updates.
 */
export const createOptimisticFunnelStatus = (
  params: UpdateFunnelStatusParams,
  previousStatus?: FunnelStatus
): FunnelStatus => {
  const baseStatus: FunnelStatus = {
    id: params.id,
    tenantId: previousStatus?.tenantId ?? '',
    name: previousStatus?.name ?? '',
    position: previousStatus?.position ?? 0,
    terminalOutcome: previousStatus?.terminalOutcome ?? null,
    systemKey: previousStatus?.systemKey ?? null,
    funnelId: previousStatus?.funnelId ?? 0,
    createdAt: previousStatus?.createdAt ?? new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    ...previousStatus,
  };

  return {
    ...baseStatus,
    ...params.data,
  };
};
